import React, { useRef, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import SaveIcon from "@material-ui/icons/Save";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
    root: {
        position: "relative"
    },
    paper: {
        position: "absolute",
        zIndex: 1
    },
    menuItem: {
        padding: "0px 70px 0px 10px"
    },
    button: {
        position: "absolute",
        right: 0
    }
}));
const missionTime = 100;
export default function DownloadUploadInput(props) {
    const { handleUpload, textFieldProps = {
        variant: "standard",
        fullWidth: true,
        inputProps: {
            readOnly: true
        }
    }, handleDownload, label, multiple, handleDelete, fileList, uploadPercent } = props;
    const classes = useStyles();
    const uploadInput = useRef(null);
    const inputRef = useRef(null);
    const mission = useRef();
    const [open, setOpen] = useState(false);
    const showValue = uploadPercent ? `正在上传...(${uploadPercent}%)` : `${fileList.length}个文件`;
    const handleClick = () => {
        if (uploadPercent)
            return;
        uploadInput.current && uploadInput.current.click();
    };
    const handleChange = () => {
        if (uploadInput.current) {
            const { files } = uploadInput.current;
            const names = [];
            if (files && files.length > 0) {
                const fileData = new FormData();
                for (let i = 0; i < files.length; i++) {
                    const file = files[i];
                    fileData.append(file.name, file);
                    names.push(file.name);
                }
                handleUpload && handleUpload(fileData, names);
                // result && (ref.current.value = "");
                uploadInput.current.value = "";
            }
        }
    };
    const enterInput = () => {
        setOpen(true);
    };
    const leaveInput = () => {
        mission.current = setTimeout(() => {
            setOpen(false);
        }, missionTime);
    };
    const enterMenu = () => {
        if (open) {
            clearTimeout(mission.current);
            mission.current = void 0;
        }
        else {
            setOpen(true);
        }
    };
    const leaveMenu = () => {
        setOpen(false);
    };
    return (<>
      <div className={classes.root}>
        <TextField ref={inputRef} value={showValue} onClick={handleUpload ? handleClick : () => { }} onMouseEnter={enterInput} onMouseLeave={leaveInput} label={label} {...textFieldProps}/>
        <input style={{ display: 'none' }} type="file" multiple={multiple} onChange={handleChange} ref={uploadInput}/>
        {open && <Paper className={classes.paper}>
          <MenuList style={{position:'fixed',backgroundColor:'#fff',maxHeight:200,overflow:'auto'}} onMouseEnter={enterMenu} onMouseLeave={leaveMenu}>
          {fileList.map((menu, index) => {
        const { value, label } = menu;
        return <MenuItem key={index} className={classes.menuItem}>
              {label}
              <div className={classes.button}>
                {handleDownload && <IconButton size="small" onClick={() => handleDownload(value)}>
                  <SaveIcon />
                </IconButton>}
                {handleDelete && <IconButton size="small" onClick={() => handleDelete(value)}>
                  <DeleteIcon />
                </IconButton>}
              </div>
            </MenuItem>;
    })}
          </MenuList>
        </Paper>}
      </div>
    </>);
}
